import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

const UserDetails = ({ CloseUserdetailsModal, userdetails, startDate, endDate, employedata }) => {
  const { emp_name, supervisor_details, activity, total_hours, total_perdim } = employedata;

 const formatDate = (date) => {
  return dayjs(date).format("MMM D, YYYY");
};


  // Flatten work_details from all activity items into a single array
  const allWorkDetails = activity
    .flatMap((item) => (item.work_details && item.work_details.length > 0 ? item.work_details : []))
    .filter(Boolean);
// Convert HH:MM:SS -> decimal (ignoring seconds)
const HHMMSSToDecimal = (time) => {
  if (!time) return 0;
  const [hh, mm] = time.split(":"); // ignore seconds
  const hours = parseInt(hh, 10) || 0;
  const minutes = parseInt(mm, 10) || 0;
  return (hours + minutes / 60).toFixed(2); // keep 2 decimals
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div
        className={`bg-white rounded-lg shadow-lg ${
          allWorkDetails.length === 1 ? 'w-[40%]' : 'w-[70%]'
        } p-6 relative`}
      >
        <div className="flex flex-col items-center border-b pb-3">
          <div className="flex w-full justify-between">
            <h3 className="text-xl text-red-800 font-semibold font-inter">{emp_name}</h3>
            <button onClick={CloseUserdetailsModal} className="text-xl font-bold">
              <CloseIcon />
            </button>
          </div>
          <div className="flex gap-1 w-full flex-start font-semibold font-Font1">
            <span>{formatDate(startDate)}</span> <span className="mx-2">-</span>{' '}
            <span>{formatDate(endDate)}</span>
          </div>
        </div>

        <div className="mt-4 max-h-[80vh] overflow-y-auto custom-scrollbar">
          <div className="mt-2">
            {allWorkDetails.length > 0 ? (
              <div className={`grid grid-flow-row ${allWorkDetails.length === 1 ? 'grid-cols-1' : 'grid-cols-2'}`}>
                {allWorkDetails.map((workItem, workIndex) => (
                  <div key={workIndex} className="border p-4 m-2 my-4 rounded-lg shadow-sm bg-gray-100">
                    <div className="flex w-full justify-end">
                      <div
                        className={`font-inter ${
                          workItem.status === 'PENDING'
                            ? 'text-[#A16207] bg-[#FEF9C3]'
                            : 'text-green-900 bg-green-400'
                        } text-xs px-2 py-[2px] rounded-full`}
                      >
                        {workItem.status}
                      </div>
                    </div>
                    <div className="flex items-center gap-2 my-2">
                      <div className="font-inter font-semibold text-md font-Font1 text-red-800">
                        {emp_name}
                      </div>
                    </div>

                    <div className="flex items-center justify-between gap-2 my-2">
                      <div className="font-inter font-semibold text-sm text-red-800 text-left">
                        Job: <span className="font-normal text-[black]">{workItem.jobDescription}</span>
                      </div>
                      <div className="px-2 py-1 text-sm font-inter bg-red-200 rounded-xl">
                        {workItem.job_id}
                      </div>
                    </div>

                    <div className="flex items-center justify-between gap-4 pb-4 border-b my-2">
                      <div className="font-inter font-semibold text-sm text-red-800 text-left">
                        Cost: <span className="font-normal text-[black]">{workItem.costcodeDescription}</span>
                      </div>
                      <div className="px-2 py-1 text-sm font-inter bg-red-200 rounded-xl">
                        {workItem.cost_code_id}.00
                      </div>
                    </div>

                    <div className="flex justify-between border-b pb-1 mb-1">
                      <div className="flex items-center flex-col gap-4">
                        <div className="font-inter text-gray-500 text-sm">Clock In</div>
                        {new Date(workItem.clock_in).toLocaleTimeString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })}
                      </div>
                      <div className="flex items-center flex-col gap-4">
                        <div className="font-inter text-gray-500 text-sm">Clock Out</div>
                        {new Date(workItem.clock_out).toLocaleTimeString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })}
                      </div>
                      <div className="flex items-center flex-col gap-4">
                        <div className="font-inter text-gray-500 text-sm">Break</div>
                        {workItem.break_time >= 60
                          ? `${(workItem.break_time / 60).toFixed(1)} hrs`
                          : `${workItem.break_time} mins`}
                      </div>
                    </div>

                    <div className="flex justify-between">
                      <div className="flex items-center flex-col gap-4">
                        <div className="font-inter text-gray-500 text-sm">Per Diem</div>$
                        {workItem.perdim}
                      </div>
                      <div className="flex items-center flex-col gap-4">
                        <div className="font-inter text-gray-500 text-sm">Total Hours</div>
                        {/* {workItem.hours} */}
                          {HHMMSSToDecimal(workItem.hours)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No data found.</p> // Consolidated to show only one message
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;